import React, { Suspense } from 'react';
import { ErrorBoundary } from './error-boundary';

interface CodeSplitWrapperProps {
  children: React.ReactNode;
  fallback?: React.ReactNode;
  errorFallback?: React.ReactNode;
  name?: string;
}

export const CodeSplitWrapper = ({ 
  children, 
  fallback, 
  errorFallback,
  name = 'Component'
}: CodeSplitWrapperProps) => {
  const defaultFallback = (
    <div className="flex items-center justify-center p-8">
      <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-primary"></div>
      <span className="ml-2 text-sm text-muted-foreground">Loading {name}...</span>
    </div>
  );

  const defaultErrorFallback = (
    <div className="flex items-center justify-center p-8 bg-destructive/10 rounded-lg">
      <span className="text-sm text-destructive">Failed to load {name}</span>
    </div>
  );

  return (
    <ErrorBoundary fallback={errorFallback || defaultErrorFallback}>
      <Suspense fallback={fallback || defaultFallback}>
        {children}
      </Suspense>
    </ErrorBoundary>
  );
};